import React from 'react';
import { DefaultHeader, HeaderWithSubMenus, MainWrapperForDefaultNavigation } from 'mm-ui-components';
import { MainWrapperConfigThemeKey } from 'mm-ui-components/dist/src/base/wrappers/mainWrapper/mainWrapper.theme';
import { useSelector } from 'react-redux';
import { FooterConnected } from './FooterConnected';
import { getHeader, getSubHeader } from '../../store/navigation/default/header/header.selectors';
import { getMenu } from '../../store/navigation/default/menu/menu.selectors';
import { getEditionEndpoint, getPagePath } from '../../store/config/config.selectors';

interface DefaultNavigationLayoutProps {
  mainWrapperConfigThemeKey: MainWrapperConfigThemeKey;
}

const DefaultHeaderConnected: React.FunctionComponent = () => {
  const header = useSelector(getHeader);
  const menu = useSelector(getMenu);
  const pagePath = useSelector(getPagePath);
  const editionEndpoint = useSelector(getEditionEndpoint);
  return <HeaderWithSubMenus {...header} menu={menu} pagePath={pagePath} editionEndpoint={editionEndpoint} />;
};

export const DefaultNavigationLayout: React.FunctionComponent<DefaultNavigationLayoutProps> = props => {
  const { children, mainWrapperConfigThemeKey } = props;
  const doesSubHeaderExist = !!useSelector(getSubHeader);
  return (
    <DefaultHeader doesSubHeaderExist={doesSubHeaderExist}>
      <DefaultHeaderConnected />
      <MainWrapperForDefaultNavigation configThemeKey={mainWrapperConfigThemeKey}>
        {children}
      </MainWrapperForDefaultNavigation>
      <FooterConnected />
    </DefaultHeader>
  );
};
